export default __webpack_public_path__ + "static/media/slider-1.1a597d68.jpg";